const getDoorbellEntranceText = (isEntrance) => {
  if (isEntrance === null) return 'Ingreso / Egreso'
  return isEntrance ? 'Ingreso' : 'Egreso'
}

export const getTypeLabel = (type, payload, doorbell) => {
  if (!type) return ''
  switch (type.toUpperCase()) {
    case 'LOGIN_FAILED':
      return 'Login fallido'
    case 'LOGIN_SUCCESS':
      return 'Login exitoso'
    case 'OPEN_DOOR':
      if (payload?.doorBellType === 'GATE') {
        return 'Portón abierto por residente'
      }
      return `${getDoorbellEntranceText(
        doorbell?.isEntrance
      )} por Reco facial a residente` // TODO check if we can get doorbell info to mark entrance and exit
    case 'OPEN_DOOR_INVITED':
      if (payload?.doorBellType === 'GATE') {
        return 'Portón abierto por invitado'
      }

      return `${getDoorbellEntranceText(
        doorbell?.isEntrance
      )} por Reco facial a visita` // TODO check if we can get doorbell info to mark entrance and exit
    case 'OPEN_DOOR_PIN':
      if (payload?.doorBellType === 'GATE') {
        return 'Portón abierto por invitado usando PIN'
      }

      return 'Ingreso por PIN a visita' // TODO check if we can get doorbell info to mark entrance and exit
    case 'SOS':
      return 'SOS desde dispositivo móvil de residente'
    case 'RINGING':
      return 'Llamando'
    case 'MANUAL_ENTRY':
      return 'Ingreso concedido por operador'
    case 'MANUAL_EXIT':
      return 'Egreso concedido por operador'
    case 'ERROR':
      return 'Error'
    case 'GATES':
      return 'Portones'
    default:
      return type
  }
}

export const isFromOperator = (type) => {
  if (!type) return false
  switch (type.toUpperCase()) {
    case 'MANUAL_ENTRY':
    case 'MANUAL_EXIT':
      return true
    default:
      return false
  }
}

export const isFaceReco = (type) => {
  if (!type) return false
  switch (type.toUpperCase()) {
    case 'OPEN_DOOR':
    case 'OPEN_DOOR_INVITED':
      return true
    default:
      return false
  }
}
